import { render, staticRenderFns } from "./DataClientComponent.vue?vue&type=template&id=630591c7&scoped=true"
import script from "./DataClientComponent.vue?vue&type=script&lang=js"
export * from "./DataClientComponent.vue?vue&type=script&lang=js"
import style0 from "./DataClientComponent.vue?vue&type=style&index=0&id=630591c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630591c7",
  null
  
)

export default component.exports